/*
 * droniq.js – eigene, hersteller-unabhängige JS-Datei.
 * Wird nach theme.js geladen. Leg hier dein projekteigenes JS ab,
 * statt theme.js (Concept von RoarTheme) zu editieren.
 */

// Share-Buttons (Kopieren/Drucken) und Anfrage-Formular (droniq)
document.addEventListener('click', async (event) => {
  const copyButton = event.target.closest('[data-share-copy]');
  if (copyButton) {
    const url = copyButton.getAttribute('data-share-copy');
    if (navigator.clipboard && url) {
      await navigator.clipboard.writeText(url);
      copyButton.setAttribute('data-copied', 'true');
      setTimeout(() => copyButton.removeAttribute('data-copied'), 2000);
    }
    return;
  }

  if (event.target.closest('[data-share-print]')) {
    window.print();
    return;
  }

  const inquiryLink = event.target.closest('a[href="#DroniqInquiryForm"]');
  if (inquiryLink) {
    const inquiryForm = document.getElementById('DroniqInquiryForm');
    if (inquiryForm) {
      inquiryForm.classList.add('is-visible');
    }
  }
});

// BSS B2B (Rabattlisten): Die App schreibt ihre Preise per JS in unsichtbare Quellen
// ([data-droniq-bss-source], .droniq-bss-source). Hier werden sie in die Theme-Preise
// uebertragen: fett der BSS-Preis netto, darunter brutto, durchgestrichen der Preis
// vor dem BSS-Rabatt (netto, mit Steuerhinweis). Ohne BSS-Rabatt bleibt alles, wie
// Liquid es gerendert hat.
(() => {
  const TAX_RATE = 0.19;

  // BSS gibt entweder "€1.234,56" aus oder zwei Spans (alt durchgestrichen, neu).
  const toCents = (text) => {
    const digits = (text || '').replace(/[^\d]/g, '');
    return digits ? parseInt(digits, 10) : null;
  };

  const readSource = (source) => {
    if (!source) return null;
    const spans = [...source.querySelectorAll('span')].filter((span) => !span.querySelector('span'));
    if (spans.length >= 2) {
      return { original: toCents(spans[0].textContent), final: toCents(spans[spans.length - 1].textContent) };
    }
    return { original: null, final: toCents(source.textContent) };
  };

  const money = (cents, withCurrency = theme.settings.currencyCodeEnabled) => theme.Currency.formatMoney(
    cents,
    withCurrency ? theme.settings.moneyWithCurrencyFormat : theme.settings.moneyFormat
  );

  // Erneutes Anwenden nur, wenn sich die Werte geaendert haben (eigene Aenderungen
  // loesen den MutationObserver ebenfalls aus).
  const once = (element, key) => {
    if (element.dataset.droniqBssApplied === key) return false;
    element.dataset.droniqBssApplied = key;
    return true;
  };

  const applyProductPrice = (box) => {
    const source = box.querySelector('[data-droniq-bss-source] [bss-b2b-product-active], [data-droniq-bss-source] > span');
    const value = readSource(source);
    const themePrice = parseInt(box.dataset.price, 10);
    if (!value || !value.final || value.final === themePrice) return;

    const original = value.original && value.original > value.final ? value.original : themePrice;
    if (!once(box, `${value.final}-${original}`)) return;

    const fromHtml = box.dataset.fromHtml;
    const withPrefix = (html) => (fromHtml ? fromHtml.replace('[price]', html) : html);

    const net = box.querySelector('.price__net');
    if (net) net.innerHTML = withPrefix(money(value.final));
    const gross = box.querySelector('.price__gross');
    if (gross) gross.innerHTML = withPrefix(money(Math.round(value.final * (1 + TAX_RATE))));

    // Streichpreis wie der regulaere Preis: netto, darunter brutto mit "inkl. MwSt."
    // (gleicher Aufbau wie in product-price.liquid).
    let saleBlock = box.querySelector('.price__sale-block');
    if (!saleBlock) {
      const saleRow = (attribute, noteClass, noteText) => {
        const row = document.createElement('span');
        row.className = 'price__sale-row';
        row.innerHTML = `<span class="price__sale flex items-center h-auto relative" ${attribute}></span>`;
        if (noteText) {
          const note = document.createElement('span');
          note.className = `price__tax-note ${noteClass}`;
          note.textContent = noteText;
          row.append(note);
        }
        return row;
      };
      saleBlock = document.createElement('span');
      saleBlock.className = 'price__sale-block';
      saleBlock.append(saleRow('data-droniq-sale-net', 'price__tax-note--net', box.dataset.taxNote));
      if (box.dataset.taxNoteGross) {
        saleBlock.append(saleRow('data-droniq-sale-gross', 'price__tax-note--sale', box.dataset.taxNoteGross));
      }
      box.prepend(saleBlock);
    }
    saleBlock.querySelector('[data-droniq-sale-net]').innerHTML = withPrefix(money(original));
    const saleGross = saleBlock.querySelector('[data-droniq-sale-gross]');
    if (saleGross) saleGross.innerHTML = withPrefix(money(Math.round(original * (1 + TAX_RATE))));
    box.classList.add('price--on-sale');
    box.dataset.droniqBssFinal = value.final;
    box.dataset.droniqBssOriginal = original;
  };

  // "Sparen Sie x %" aus dem BSS-Preis statt aus dem Shopify-Vergleichspreis (Liquid).
  const applySaveBadge = (badge) => {
    const container = badge.closest('.product-card, product-info');
    const box = container?.querySelector('[id^="Price-"] [data-droniq-bss-price]') || container?.querySelector('[data-droniq-bss-price]');
    const final = parseInt(box?.dataset.droniqBssFinal, 10);
    const original = parseInt(box?.dataset.droniqBssOriginal, 10);
    if (!final || !(original > final)) return;
    if (!once(badge, `${final}-${original}`)) return;

    const type = badge.dataset.droniqBssSave;
    if (type !== 'label') {
      const amount = type === 'dollar'
        ? money(Math.round((original - final) * (1 + TAX_RATE)))
        : `${Math.round(((original - final) * 100) / original)}%`;
      badge.innerHTML = badge.dataset.saveHtml.replace('[amount]', amount);
    }
    badge.hidden = false;
  };

  const cartSource = (key, attribute) => document.querySelector(
    `[bss-b2b-cart-item-key="${CSS.escape(key)}"][${attribute}]`
  );

  const applyCartItem = (box) => {
    // BSS schreibt bei Rabatt beide Preise (alt + neu) in die "original"-Quelle,
    // die "final"-Quelle bleibt dann unveraendert.
    const value = readSource(cartSource(box.dataset.droniqBssItem, 'bss-b2b-item-original-price'));
    const final = value?.original ? value.final : readSource(cartSource(box.dataset.droniqBssItem, 'bss-b2b-item-final-price'))?.final;
    const original = value?.original || null;
    if (!final || final === parseInt(box.dataset.final, 10)) return;
    if (!once(box, `${final}-${original}`)) return;

    // Drawer und Warenkorbseite rendern den Preis unterschiedlich; alles ausser dem
    // Grundpreis (.unit-price) wird ersetzt.
    [...box.children].forEach((element) => {
      const isUnitPrice = element.matches('.unit-price')
        || (element.matches('.sr-only') && element.nextElementSibling?.matches('.unit-price'));
      if (!isUnitPrice) element.remove();
    });
    const regular = document.createElement('span');
    regular.className = 'price__regular whitespace-nowrap';
    regular.innerHTML = money(final);
    box.prepend(regular);
    if (original && original > final) {
      const sale = document.createElement('span');
      sale.className = 'price__sale inline-flex items-center relative';
      sale.innerHTML = money(original);
      box.prepend(sale);
      box.classList.add('price--on-sale');
    }
  };

  const applyAmount = (element, source, withCurrency) => {
    const final = readSource(source)?.final;
    if (!final || final === parseInt(element.dataset.final, 10)) return;
    if (!once(element, `${final}`)) return;
    element.innerHTML = money(final, withCurrency);
  };

  const apply = () => {
    if (!window.theme?.Currency) return;
    document.querySelectorAll('[data-droniq-bss-price]').forEach(applyProductPrice);
    document.querySelectorAll('[data-droniq-bss-save]').forEach(applySaveBadge);
    document.querySelectorAll('[data-droniq-bss-item]').forEach(applyCartItem);
    document.querySelectorAll('[data-droniq-bss-line]').forEach((element) => {
      applyAmount(element, cartSource(element.dataset.droniqBssLine, 'bss-b2b-final-line-price'), theme.settings.currencyCodeEnabled);
    });
    document.querySelectorAll('[data-droniq-bss-total]').forEach((element) => {
      applyAmount(element, element.parentElement.querySelector('[bss-b2b-cart-total-price]'), true);
    });
  };

  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      apply();
    });
  };

  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  document.addEventListener('DOMContentLoaded', schedule);
  schedule();
})();

// BSS-Mengenstaffel im Warenkorb: BSS reagiert nur auf den kleinen Pfeil-Button. Klicks auf
// die restliche Flaeche von "Mengenrabatte anzeigen" an den Pfeil weiterreichen.
document.addEventListener('click', (event) => {
  const header = event.target.closest('.bss-b2b-cart-item-qty-table-header');
  if (!header || event.target.closest('.bss-b2b-up-down-qb-btn')) return;
  header.querySelector('.bss-b2b-up-down-qb-btn')?.click();
});

// CookieFirst -> Shopify Customer Privacy API. CookieFirst kennt die Shopify-API nicht; ohne
// diese Bruecke richten sich Shopify Analytics, Web-Pixel und Apps (Google & YouTube, Meta)
// nicht nach der Auswahl im Banner. Kategorien: performance -> analytics,
// advertising -> marketing + sale_of_data, functional -> preferences.
(() => {
  const toShopify = (consent) => ({
    analytics: Boolean(consent.performance),
    marketing: Boolean(consent.advertising),
    preferences: Boolean(consent.functional),
    sale_of_data: Boolean(consent.advertising),
  });

  const withCustomerPrivacy = (callback) => {
    if (window.Shopify?.customerPrivacy) return callback(window.Shopify.customerPrivacy);
    window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
      if (!error && window.Shopify?.customerPrivacy) callback(window.Shopify.customerPrivacy);
    });
  };

  // force: Auswahl im Banner immer weitergeben; sonst nur, wenn Shopify etwas anderes kennt
  const apply = (consent, force) => {
    if (!consent) return;
    const wanted = toShopify(consent);
    withCustomerPrivacy((privacy) => {
      const current = privacy.currentVisitorConsent?.() || {};
      const same = Object.keys(wanted).every((key) => (current[key] === 'yes') === wanted[key]);
      if (!force && same) return;
      privacy.setTrackingConsent(wanted, () => {});
    });
  };

  window.addEventListener('cf_consent', (event) => apply(event.detail, true));
  window.addEventListener('cf_consent_loaded', () => apply(window.CookieFirst?.consent, false));
  window.addEventListener('cf_init', () => apply(window.CookieFirst?.consent, false));
  apply(window.CookieFirst?.consent, false);
})();
